"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserContext = void 0;
var react_1 = require("react");
exports.UserContext = (0, react_1.createContext)(undefined);
//# sourceMappingURL=context.js.map